var blogArticle4i = function(){
	const init = () => {
		const mainContent = document.querySelector("#mainContent");
		if(mainContent.querySelector(".accordionHeader")){
			const sourceAccordion = new getAccordions4i();
			sourceAccordion.init(mainContent);
		}
	};
	return{
		Init: init
	};
};

(function(){
	const blogArticle = new blogArticle4i();
	blogArticle.Init();
})();